<div class="collage">
    <div class="wrapper services">
        <div class="cancella" *ngIf="cancellazione">
            {{'base.cancellazione_gratuita' | translate | uppercase}}
        </div>
        <!-- <h3 *ngIf="tipologie.includes('D')">
            {{ 'generale.degustazione' | translate | uppercase }}
        </h3>
        <h3 *ngIf="tipologie.includes('W')">
            {{ 'generale.degustazioneweb' | translate | uppercase }}
        </h3>
        <h3 *ngIf="tipologie.includes('R')">
            {{ 'generale.ristorazione' | translate | uppercase }}
        </h3>
        <h3 *ngIf="tipologie.includes('P')">
            {{ 'generale.pernottamento' | translate | uppercase }}
        </h3>
        <h3 *ngIf="tipologie.includes('C')">
            {{ 'generale.picnic' | translate | uppercase }}
        </h3>
        <h3 *ngIf="tipologie.includes('T')">
            {{ 'generale.espdeluxe' | translate | uppercase }}
        </h3> -->
    </div>
</div>